const handleSelectChange = (initialData, nameInput, valueInput) => {
  const updateValue = { ...initialData };
  // console.log("nameInput", nameInput);

  // console.log("valueInput", valueInput);
  // const defaultSelect = { label: "" };
  const defaultSelect = null;
  if (valueInput.reason === "clear") {
    updateValue[nameInput] = defaultSelect;
  } else if (valueInput.isResultObject) {
    updateValue[nameInput] = valueInput.newValue;
  } else if (nameInput === "especeCategory") {
    // console.log("AAAA", nameInput === "especeCategory");
    updateValue[nameInput] = valueInput.newValue.value;
  } else {
    updateValue[nameInput] = valueInput.newValue.label;
  }
  // console.log("updateValue", updateValue);
  return updateValue;
};
export default handleSelectChange;
